module.exports = __webpack_public_path__ + "img/carDrivingAnnualReview.6c0b4c9b.png";